@if (_filterChips && _filterChips?.length > 0) {
  <div class="filter-chip-panel">
    <div class="filter-chip-elements">
      <span class="btn-action-clear-filter" title="Clear all filters" (click)="clearAllFilters()"></span>
      <span class="advanced-filter-label">Filters applied:</span>
      @for (filterChip of _filterChips; track filterChip) {
        @if (displayFilter(filterChip[0])) {
          <div class="filter-chip-element">
            <irb-filter-chip-element [filterChip]="filterChip" [mapData]="getDataMap(filterChip[0])" (removeFilterItem)="onRemoveFilterItem($event)"></irb-filter-chip-element>
          </div>
        }
      }
    </div>
  </div>
}
